/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { RecurlyCouponInput } from '@nexus/fff-payments';

import './styles.css';

const CouponSelector = ({
  plan, onApplyCoupon, couponsApplied, error, initialCouponCode, onRemoveCoupon,
}) => {
  const [isOpen, setIsOpen] = useState(!!initialCouponCode);

  const toggleIsOpen = () => setIsOpen(!isOpen);

  const handleApply = ({ coupon, price }) => {
    const discount = price && price.now && price.now.discount ? price.now.discount : 0;
    onApplyCoupon(coupon, discount);
  };

  return (
    <section className="coupon-selector">
      <div className={cx('coupon-selector__form', { 'is-open': isOpen })}>
        <button type="button" onClick={toggleIsOpen}>
          Got a Coupon Code?
        </button>
        <RecurlyCouponInput plan={plan} onApply={handleApply} error={error} initialCouponCode={initialCouponCode} />
      </div>
      {couponsApplied.length > 0 && (
        <div className="coupon-selector__applied">
          {couponsApplied.map(({ message, code }) => (
            <div key={message} className="coupon-selector__applied__coupon">
              <p className="title correct">
                {message}
              </p>
              <i
                className="fas fa-times close"
                onClick={() => onRemoveCoupon(code)}
                onKeyPress={() => onRemoveCoupon(code)}
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

CouponSelector.defaultProps = {
  onApplyCoupon: () => {},
  error: {},
  couponsApplied: [],
  initialCouponCode: null,
  plan: null,
};

CouponSelector.propTypes = {
  onApplyCoupon: PropTypes.func,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  couponsApplied: PropTypes.arrayOf(PropTypes.object),
  initialCouponCode: PropTypes.string,
  plan: PropTypes.string,
};

export default CouponSelector;
